import axios from 'axios';

import { ErrorCodeConstant, ErrorMessage, HttpError } from '../error';

const {
  SUCCESS,
  NOT_FOUND,
  FORBIDDEN,
  BAD_REQUEST,
  BAD_GATEWAY,
  UNAUTHORIZED,
  UNKNOWN_ERROR,
  NOT_IMPLEMENTED,
  RESPONSE_TIME_OUT,
  SERVICE_UNAVAILABLE,
  INTERNAL_SERVER_ERROR,
  NOT_SUPPORT_HTTP_VERSION,
} = ErrorCodeConstant;
const ErrorCodeConstantArr = [
  SUCCESS,
  NOT_FOUND,
  FORBIDDEN,
  BAD_REQUEST,
  BAD_GATEWAY,
  UNAUTHORIZED,
  UNKNOWN_ERROR,
  NOT_IMPLEMENTED,
  RESPONSE_TIME_OUT,
  SERVICE_UNAVAILABLE,
  INTERNAL_SERVER_ERROR,
  NOT_SUPPORT_HTTP_VERSION,
];

const axiosInstance = axios.create({
  withCredentials: false, // 支持动态传入
});
// 添加请求拦截器
axiosInstance.interceptors.request.use(
  async (config) => {
    let configData = config;
    axiosInstance?.options?.requestInterceptor && (configData = await axiosInstance.options.requestInterceptor(config));
    return configData;
  },
  (error) =>
    // 对请求错误做些什么
    Promise.reject(error),
);

// 添加响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    axiosInstance?.options?.responseInterceptor && (response = axiosInstance.options.responseInterceptor(response));
    if (axiosInstance?.options) {
      const { notHandleError = false } = axiosInstance.options;
      if (notHandleError) {
        delete axiosInstance.options;
        return response.data;
      }
    }
    delete axiosInstance.options;
    // 对响应数据做点什么
    const { status, statusText } = response;
    if (status === SUCCESS) {
      return {
        code: status,
        msg: statusText,
        data: response.data,
        headers: response.headers,
      };
    }
    ErrorCodeConstantArr.map((code) => new HttpError(code, ErrorMessage[code], response));
  },
  (error) =>
    // 对响应错误做点什么
    Promise.reject(error),
);

export default axiosInstance;
